<template>
    <v-dialog v-model="modal" width="900">
        <v-card>
            <component :is="component" :product="entry">
                <template v-slot:price="{offer}">
                    <tour-offer-delta-button :offer="offer" :offer-key="offerKey" :entry-name="entry.entryName" />
                </template>
            </component>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'
    import {EventBus, SHOW_TOUR_TRANSFER_INFO} from '@/utils/event-bus'
    import TourOfferDeltaButton from '@/components/tours/search/TourOfferDeltaButton.vue'
    import TransferCard from '~src/components/transfers/search/offers/transferCard.src'
    import TransferCardMobile from '~/components/transfers/search/offers/TransferCardMobile.vue'

    @Component({
        components: {
            TransferCard,
            TransferCardMobile,
            TourOfferDeltaButton,
        },
    })
    export class TourTransferInfoModal extends Vue {
        @Prop({required: true}) searchRequest

        modal = false
        entry = {}
        offerKey = null

        mounted() {
            EventBus.$on(SHOW_TOUR_TRANSFER_INFO, this.showModal)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_TOUR_TRANSFER_INFO, this.showModal)
        }

        async showModal({entry, offerKey}) {
            try {
                const info = await this.$api.transferInfo.get({offerKey: entry.offers[0].offerKey})
                const imageUrl =
                    info.images && info.images.length
                        ? info.images?.find(item => item.mainImage).url || info.images[0].url
                        : ''

                this.entry = {
                    ...entry,
                    info: {
                        name: info.name,
                        description: info.shortDescription ? info.shortDescription : '',
                        imageUrl,
                    },
                }
                this.offerKey = offerKey
                this.modal = true
            } catch (e) {
                this.entry = {}
                this.offerKey = null
                this.modal = false
            }
        }

        get component() {
            return !this.$breakpoint.smAndDown
                ? resolveComponent('TransferCard')
                : resolveComponent('TransferCardMobile')
        }
    }

    export default TourTransferInfoModal
</script>
